<template>
  <div class="fenxiao-apply">
    <!-- 页面头部 -->
    <div class="page-header">
      <el-button type="text" @click="goBack" class="back-btn">
        <i class="el-icon-arrow-left"></i>
        返回
      </el-button>
      <h2 class="page-title">{{ fenxiaoWords.fenxiao_name }}申请</h2>
    </div>

    <div class="apply-container" v-if="status === ''">
      <!-- 申请头图 -->
      <div class="apply-header" v-if="fenXiaoAgreement.agreement.img">
        <img :src="$util.img(fenXiaoAgreement.agreement.img)" alt="申请头图" class="header-img">
      </div>
      <div class="apply-header default-header" v-else>
        <div class="header-content">
          <h3>请填写申请信息</h3>
          <!-- <img src="/static/images/fenxiao/apply-icon.png" alt="申请图标" class="apply-icon"> -->
        </div>
      </div>

      <!-- 申请表单 -->
      <div class="apply-form-card">
        <el-form :model="formData" :rules="rules" ref="applyForm" label-width="120px">
          <el-form-item label="邀请人：">
            <span class="invite-info">{{ sourceMemberInfo.fenxiao_name }}</span>
          </el-form-item>
          
          <el-form-item :label="fenxiaoWords.fenxiao_name + '名称：'" prop="fenXiaoName">
            <el-input
              v-model="formData.fenXiaoName"
              :placeholder="'请输入' + fenxiaoWords.fenxiao_name + '名称'"
              maxlength="30"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item label="手机号：" prop="mobile">
            <el-input
              v-model="formData.mobile"
              placeholder="请输入手机号"
              maxlength="11"
            ></el-input>
          </el-form-item>

          <!-- 协议确认 -->
          <el-form-item v-if="isAgreement">
            <el-checkbox v-model="isChecked">
              我已阅读并了解
              <el-button type="text" @click="openAgreement" class="agreement-link">
                【{{ fenxiaoWords.fenxiao_name }}申请协议】
              </el-button>
            </el-checkbox>
          </el-form-item>

          <!-- 提交按钮 -->
          <el-form-item>
            <el-button 
              type="primary" 
              @click="applyFenXiao" 
              :loading="isSub"
              class="apply-btn"
            >
              申请成为{{ fenxiaoWords.fenxiao_name }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 申请条件说明 -->
      <div class="apply-condition" v-if="fenxiaoConfig.fenxiao_condition == 2 || fenxiaoConfig.fenxiao_condition == 3">
        <div class="condition-card">
          <h4>{{ fenxiaoWords.fenxiao_name }}申请条件</h4>
          <p v-if="fenxiaoConfig.fenxiao_condition == 2">
            申请成为{{ fenxiaoWords.fenxiao_name }}，需要您的消费次数达到{{ fenxiaoConfig.consume_count }}次
          </p>
          <p v-if="fenxiaoConfig.fenxiao_condition == 3">
            申请成为{{ fenxiaoWords.fenxiao_name }}，需要您的消费金额达到{{ fenxiaoConfig.consume_money }}元
          </p>
        </div>
      </div>
    </div>

    <!-- 申请状态页面 -->
    <div class="apply-status" v-else>
      <div class="status-content">
        <!-- <img src="/static/images/fenxiao/status-icon.png" alt="状态图标" class="status-icon"> -->
        <p v-if="status == 1" class="status-text">
          您已提交{{ fenxiaoWords.fenxiao_name }}申请，等待平台审核
        </p>
        <div v-else-if="status == -1" class="rejected-status">
          <p class="status-text">您提交的{{ fenxiaoWords.fenxiao_name }}申请已被拒绝，请再接再厉</p>
          <el-button type="primary" @click="againApply" class="retry-btn">重新申请</el-button>
        </div>
      </div>
    </div>

    <!-- 协议弹窗 -->
    <el-dialog
      :title="fenXiaoAgreement.document && fenXiaoAgreement.document.title ? fenXiaoAgreement.document.title : '协议内容'"
      :visible.sync="agreementVisible"
      width="60%"
      class="agreement-dialog"
      v-if="fenXiaoAgreement.document"
    >
      <div class="agreement-content" v-html="fenXiaoAgreement.document.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="agreementVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getFenxiaoApplyInfo, submitFenxiaoApply, getFenxiaoAgreement, getFenxiaoConfig, getFenxiaoBasicsConfig, getFenxiaoApplyStatus, getSourceMemberInfo, applyFenxiao } from '@/api/fenxiao'

export default {
  name: 'FenxiaoApply',
  data() {
    return {
      // 表单数据
      formData: {
        fenXiaoName: '',
        mobile: ''
      },
      // 表单验证规则
      rules: {
        fenXiaoName: [
          { required: true, message: '请输入推广员名称', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      // 推荐人信息
      sourceMemberInfo: {
        fenxiao_name: '无'
      },
      // 协议信息
      fenXiaoAgreement: {
        agreement: {},
        document: {}
      },
      // 分销配置
      fenxiaoConfig: {
        fenxiao_condition: 0
      },
      basicsConfig: {},
      // 状态控制
      isChecked: false,
      isAgreement: false,
      agreementVisible: false,
      status: '',
      isSub: false,
      // 分销词汇
      fenxiaoWords: {
        fenxiao_name: '推广员',
        withdraw: '提现',
        concept: '推广',
        my_team: '我的团队'
      }
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    // 初始化页面
    async initPage() {
      try {
        await this.loadFenxiaoConfig()
        await this.getFenxiaoBasicsConfig()
        await this.getAgreement()
        await this.applyStatus()
        await this.getSourceMemberInfo()
      } catch (error) {
        console.error('页面初始化失败:', error)
      }
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },

    // 获取分销配置
    async loadFenxiaoConfig() {
      try {
        const res = await getFenxiaoConfig()
        if (res.code >= 0 && res.data) {
          this.fenxiaoConfig = res.data
        }
      } catch (error) {
        console.error('获取分销配置失败:', error)
      }
    },

    // 获取分销基本配置
    async getFenxiaoBasicsConfig() {
      try {
        const res = await getFenxiaoBasicsConfig()
        if (res.code >= 0 && res.data) {
          this.basicsConfig = res.data
        }
      } catch (error) {
        console.error('获取分销基本配置失败:', error)
      }
    },

    // 获取申请协议
    async getAgreement() {
      try {
        const res = await getFenxiaoAgreement()
        if (res.code === 0) {
          this.fenXiaoAgreement = res.data
          if (this.fenXiaoAgreement.agreement.is_agreement === '1') {
            this.isAgreement = true
          }
        }
      } catch (error) {
        console.error('获取申请协议失败:', error)
      }
    },

    // 获取申请状态
    async applyStatus() {
      try {
        const res = await getFenxiaoApplyStatus()
        if (res.code >= 0 && res.data) {
          this.status = res.data.status
          if (this.status == 2) {
            // 已通过，跳转到推广中心
            this.$router.replace('/member/fenxiao_center')
          }
        }
      } catch (error) {
        console.error('获取申请状态失败:', error)
      }
    },

    // 获取推荐人信息
    async getSourceMemberInfo() {
      try {
        const res = await getSourceMemberInfo()
        if (res.code == 0 && res.data) {
          this.sourceMemberInfo = res.data
        }
      } catch (error) {
        console.error('获取推荐人信息失败:', error)
      }
    },

    async loadApplyInfo() {
      try {
        const res = await getFenxiaoApplyInfo()
        if (res.code === 200) {
          this.applyInfo = res.data
          this.formData = { ...res.data }
        }
      } catch (error) {
        console.error('获取申请信息失败:', error)
      }
    },
    
    async loadAgreement() {
      try {
        const res = await getFenxiaoAgreement()
        if (res.code === 200) {
          this.agreementContent = res.data.content || ''
        }
      } catch (error) {
        console.error('获取协议内容失败:', error)
      }
    },
    
    async submitApply() {
      if (!this.agreeToAgreement) {
        this.$message.warning('请先同意分销协议')
        return
      }
      
      this.loading = true
      try {
        const res = await submitFenxiaoApply(this.formData)
        if (res.code === 200) {
          this.$message.success('申请提交成功，请等待审核')
          this.$router.push('/member/fenxiao_center')
        } else {
          this.$message.error(res.message || '申请提交失败')
        }
      } catch (error) {
        console.error('提交申请失败:', error)
        this.$message.error('申请提交失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 提交申请
    applyFenXiao() {
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          if (this.isAgreement && !this.isChecked) {
            this.$message.warning('请仔细阅读协议，并勾选')
            return
          }
          
          if (this.isSub) return
          this.isSub = true

          try {
            const res = await applyFenxiao({
              fenxiao_name: this.formData.fenXiaoName,
              mobile: this.formData.mobile
            })
            
            if (res.code >= 0) {
              this.$message.success('申请提交成功')
              if (this.basicsConfig.is_examine == 1) {
                await this.applyStatus()
              } else {
                this.$router.replace('/member/fenxiao_center')
              }
            } else {
              this.$message.error(res.message || '申请失败')
            }
          } catch (error) {
            this.$message.error('申请失败，请重试')
            console.error('申请失败:', error)
          } finally {
            this.isSub = false
          }
        }
      })
    },

    // 打开协议弹窗
    openAgreement() {
      if (this.isAgreement) {
        this.agreementVisible = true
      }
    },

    // 重新申请
    againApply() {
      this.status = ''
      this.formData = {
        fenXiaoName: '',
        mobile: ''
      }
      this.isChecked = false
    }
  }
}
</script>

<style lang="scss" scoped>
.fenxiao-apply {
  min-height: 100vh;
  background-color: #f5f5f5;

  .page-header {
    background: #fff;
    padding: 20px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    align-items: center;

    .back-btn {
      margin-right: 20px;
      font-size: 16px;
    }

    .page-title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
    }
  }

  .apply-container {
    max-width: 800px;
    margin: 20px auto;
    padding: 0 20px;
  }

  .apply-header {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;

    .header-img {
      width: 100%;
      height: 200px;
      object-fit: cover;
    }

    &.default-header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 40px;
      text-align: center;

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;

        h3 {
          margin: 0;
          font-size: 24px;
        }

        .apply-icon {
          width: 80px;
          height: 80px;
        }
      }
    }
  }

  .apply-form-card {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .invite-info {
      color: #666;
      font-size: 14px;
    }

    .agreement-link {
      color: #409eff;
      padding: 0;
    }

    .apply-btn {
      width: 160px;
      height: 45px;
      font-size: 16px;
      margin-top: 20px;
    }
  }

  .apply-condition {
    .condition-card {
      background: #fff;
      border-radius: 8px;
      padding: 20px;
      border-left: 4px solid #409eff;

      h4 {
        margin: 0 0 10px 0;
        color: #333;
        font-size: 16px;
      }

      p {
        margin: 0;
        color: #666;
        line-height: 1.6;
      }
    }
  }

  .apply-status {
    max-width: 600px;
    margin: 100px auto;
    text-align: center;

    .status-content {
      background: #fff;
      border-radius: 8px;
      padding: 60px 40px;

      .status-icon {
        width: 120px;
        height: 120px;
        margin-bottom: 30px;
      }

      .status-text {
        font-size: 16px;
        color: #666;
        margin-bottom: 30px;
      }

      .retry-btn {
        padding: 12px 40px;
      }
    }
  }

  .agreement-dialog {
    .agreement-content {
      max-height: 400px;
      overflow-y: auto;
      line-height: 1.8;
      color: #666;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .fenxiao-apply {
    .apply-container {
      margin: 10px;
      padding: 0 10px;
    }

    .apply-form-card {
      padding: 20px;
    }

    .apply-header.default-header {
      padding: 20px;

      .header-content {
        flex-direction: column;
        gap: 20px;

        .apply-icon {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>